const ErrorElement = () => {
  return (
    <div>
      <div>Something went wrong.</div>
      <div>Common errors:</div>
      <ul>
        <li>Server is not running.</li>
        <li>Routing incorrectly implemented.</li>
      </ul>
    </div>
  );
};

export default ErrorElement;
